import { wrapPageElement as wrap } from './src/components/RootWrapper';

export const wrapPageElement = wrap;

export const onClientEntry = () => {
  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    const reason = event.reason as Error | undefined;
    if (reason?.name === 'ChunkLoadError' || /Loading chunk \d+ failed/.test(reason?.message ?? '')) {
      window.location.reload();
    }
  });
};
